import { WButton } from "@/components/button/WButton.tsx";
import { FieldButtonGroup } from "@/components/forms/FieldButtonGroup.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import type { VirtualMachineLoc } from "@/modules/compute/vmQuery.ts";
import { AssignedToSelect } from "@/modules/network/firewall/AssignedToSelect.tsx";
import { addResourceToFirewallMutation, type FirewallWithType } from "@/modules/network/firewall/firewallApi.ts";
import { Trans } from "@lingui/react/macro";
import type { FirewallAssignedResource } from "@warrenio/api-spec/spec.oats.gen";
import { useState } from "react";

export interface AddResourceFormProps {
    item: FirewallWithType;
    onClose: () => void;
}

export function AddResourceForm({ item, onClose }: AddResourceFormProps) {
    const { location, uuid } = item;

    const addMutation = useStandardMutation(addResourceToFirewallMutation);
    const [target, setTarget] = useState<FirewallAssignedResource>();

    async function onSubmit() {
        if (!target) {
            return;
        }
        await addMutation.mutateAsync({
            location,
            uuid,
            vm_uuid: target.resource_uuid,
        });
        onClose();
    }

    function onChangeTarget(vm: VirtualMachineLoc) {
        setTarget({ resource_type: "vm", resource_uuid: vm.uuid });
    }

    return (
        <FieldButtonGroup>
            <AssignedToSelect
                defaultOpen={true}
                location={location}
                usedResourceUuids={
                    item.resources_assigned?.length ? item.resources_assigned.map((a) => a.resource_uuid) : []
                }
                onChange={onChangeTarget}
            />
            <WButton color="primary" icon="jp-icon-add" action={onSubmit}>
                <Trans>Add</Trans>
            </WButton>
            <WButton action={onClose}>
                <Trans>Close</Trans>
            </WButton>
        </FieldButtonGroup>
    );
}
